import * as React from 'react';
import * as main from "../../main.module.scss";
import * as program from "./style.module.scss";
export const Program = () => {
  return (
    <section className={program.program}>
      <div className="container">
        <h2 className={main.title}>На вебинаре мы расскажем как:</h2>
        <div className={program.wrap}>
          <ul>
            <li>сделать так, чтобы у ребенка <span>получалось учиться;</span></li>
            <li><span>создать условия</span> для успешной учёбы</li>
          </ul>
          <ul>
            <li>освоить <span>технологии самообучения</span> и покажем как это работает <span>на практике;</span></li>
            <li><span>радоваться жизни</span> и успевать в школе.</li>
          </ul>
        </div>
      </div>
    </section>
  );
};
